import React, { useContext } from 'react';
import Portal from '@components/Portal';
import './download-bar.scss';

interface DownloadBarProps {
    className?: string;
    onClose: () => void;
    onClick: () => void;
}

function DownloadBar(props: DownloadBarProps) {

    return (
        <div>
            <div className={`c-app-download ${props.className}`}>
                <img onClick={props.onClose} className='close' src={require('@images/close.svg').default} />
                <img className='logo' src={require('@images/logo.png').default} />
                <div className='content'>
                    <div className='title'>别样海外购APP</div>
                    <div className='sub-title'>新用户可限时领取<span className='yellow'>大礼包</span></div>
                </div>
                <div onClick={props.onClick} className='button'>打开APP</div>
            </div>
        </div>
    )
}

export default Portal(DownloadBar);